import { Body, Card, Headline } from "~/ui-library";

export type ArticlePullQuoteProps = {
  byline: string;
  quote: string;
};

const FloatingQuote = () => (
  <div className="flex size-l items-center justify-center rounded-3 border-1 border-primary-900 bg-white shadow-[-3px_3px_0_2px] shadow-primary-200">
    <svg
      className=""
      width="24"
      height="18"
      viewBox="0 0 24 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="fill-primary-900"
        d="M22.6592 0C23.5531 0 24 0.287823 24 0.863469C24 1.30627 23.6425 1.5941 22.9274 1.72693C21.1397 2.12546 19.6425 2.90037 18.4358 4.05166C17.2737 5.15867 16.6927 6.64207 16.6927 8.50185C16.6927 9.12177 16.9609 9.7417 17.4972 10.3616C18.0335 10.9373 18.6592 11.2915 19.3743 11.4244C20.2682 11.5572 20.9832 11.9114 21.5196 12.4871C22.1006 13.0185 22.3911 13.7048 22.3911 14.5461C22.3911 15.5203 21.9888 16.3395 21.1844 17.0037C20.3799 17.6679 19.4413 18 18.3687 18C16.6257 18 15.1955 17.3801 14.0782 16.1402C12.9609 14.9004 12.4022 13.3284 12.4022 11.4244C12.4022 9.25461 12.9385 7.30627 14.0112 5.57934C15.1285 3.80812 16.4916 2.43542 18.1006 1.46126C19.7095 0.487085 21.229 0 22.6592 0ZM10.257 0C11.1508 0 11.5978 0.287823 11.5978 0.863469C11.5978 1.30627 11.2402 1.5941 10.5251 1.72693C8.73743 2.12546 7.24022 2.90037 6.03352 4.05166C4.87151 5.15867 4.2905 6.64207 4.2905 8.50185C4.2905 9.12177 4.55866 9.7417 5.09497 10.3616C5.63129 10.9373 6.25698 11.2915 6.97207 11.4244C7.86592 11.5572 8.58101 11.9114 9.11732 12.4871C9.69832 13.0185 9.98883 13.7048 9.98883 14.5461C9.98883 15.5203 9.58659 16.3395 8.78212 17.0037C7.97765 17.6679 7.03911 18 5.96648 18C4.22346 18 2.7933 17.3801 1.67598 16.1402C0.558659 14.9004 0 13.3284 0 11.4244C0 9.25461 0.536313 7.30627 1.60894 5.57934C2.72626 3.80812 4.08939 2.43542 5.69832 1.46126C7.30726 0.487085 8.82682 0 10.257 0Z"
      />
    </svg>
  </div>
);

export const ArticlePullQuote = ({ quote, byline }: ArticlePullQuoteProps) => (
  <div className="relative">
    <div className="absolute -top-s left-s w-fit bg-white pl-[0.75rem] pr-xs md:left-[2.5rem]">
      <FloatingQuote />
    </div>
    <Card className="flex w-full flex-col justify-start gap-xs px-m pb-s pt-[1.75rem] shadow-primary-100 md:px-xl md:pb-m md:pt-[2.125rem]">
      <Headline level={3}>{quote}</Headline>
      <Body className="text-gray-800" size="small">
        {byline}
      </Body>
    </Card>
  </div>
);
